module.exports = __webpack_public_path__ + "img/icon-issue-new.924971d2.svg";